import { Form, Row, Col, DatePicker } from 'antd';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import antdMessage from '../antdMessage';
import fetchApi from '../fetchApi';
import AntDraggableModal from '../../../universal/AntDraggableModal';

const BaseLoggerClear = (props: any) => {
    const { apiId, onClose, loggerServiceUrl } = props;
    const [form] = Form.useForm(); //form 

    useEffect(() => {
    }, []);

    /** 确定 */
    const handleOk = (e: any) => {
        form.validateFields() //数据校验
            .then(async (values: any) => {
                const { clearDate } = values;
                const res = await fetchApi.DELETE(loggerServiceUrl, {
                    body: {
                        apiId,
                        apiExtend: 'clearLog',
                        apiData: {
                            clearDate: dayjs(clearDate).format('YYYY-MM-DD')
                        }
                    }
                });
                if (res.success === true) {
                    antdMessage('info', '成功', { description: '删除日志成功' });
                } else {
                    antdMessage('warning', '错误', { description: `删除日志失败，${res.message.toString()}` });
                }
                onClose(false);
            })
            .catch((err: any) => {
                antdMessage('warning', '无法通过数据校验', { description: `请输入所需数据 或者${err.message.toString()}` });
            });
    };

    return (
        <>
            <AntDraggableModal
                title={'清除日志'}
                open={true}
                onOk={(e) => handleOk(e)}
                onCancel={() => onClose()}
                closable={false}
                maskClosable={false} >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={18}>
                            <Form.Item
                                label="清除及之前日期："
                                name="clearDate"
                                rules={[{ required: true, message: '请选择日期!' }]}>
                                <DatePicker
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default BaseLoggerClear;